import React from "react";
import { AlertTriangle, CheckCircle, ChevronDown, ChevronRight, Bug } from "lucide-react";

export default function OCRComparisonPanel({ ocrData }) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  if (!ocrData) return null;

  const { winner, gemma4, cf_worker } = ocrData;

  const getScoreColor = (score) => {
    if (score > 60) return "text-green-600";
    if (score >= 30) return "text-orange-500";
    return "text-red-600";
  };

  const gemmaScore = gemma4?.quality?.score || 0;
  const cfScore = cf_worker?.quality?.score || 0;

  const isGemmaWinner = winner === "gemma4";
  const isCfWinner = winner === "cf_worker";

  return (
    <div
      className="mt-4 rounded-md overflow-hidden"
      style={{ backgroundColor: "#FFFBEB", border: "1px solid #FDE68A" }}
    >
      <div
        className="flex items-center justify-between p-3 cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2">
          <Bug className="w-5 h-5 text-red-500" />
          <span className="font-semibold text-amber-900">🔬 Comparaison OCR [DEBUG]</span>
        </div>
        <div className="text-amber-700">
          {isExpanded ? <ChevronDown className="w-5 h-5" /> : <ChevronRight className="w-5 h-5" />}
        </div>
      </div>

      {isExpanded && (
        <div className="border-t border-amber-200">
          <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x border-b border-amber-200 divide-amber-200">
            {/* Gemma 4 Column */}
            <div className={`p-4 ${isGemmaWinner ? "bg-[#F0FDF4]" : ""}`}>
              <h3 className="font-bold text-gray-800 mb-2">Gemma 4 31B (Google)</h3>
              {isGemmaWinner && (
                <div className="flex items-center gap-1 text-green-600 font-bold mb-2">
                  <CheckCircle className="w-4 h-4" /> WINNER
                </div>
              )}

              <div className="space-y-1 text-sm text-gray-700">
                <div>
                  Score : <span className={`font-bold ${getScoreColor(gemmaScore)}`}>
                    {gemmaScore.toFixed(1)} / 100
                  </span>
                </div>
                <div className="flex gap-4">
                  <span>Dosages : {gemma4?.quality?.dosages || 0}</span>
                  <span>Posol. : {gemma4?.quality?.posologies || 0}</span>
                </div>
                <div className="flex items-center gap-1">
                  <span>Artefacts : </span>
                  <span className={(gemma4?.quality?.artifact_ratio || 0) > 0.01 ? "text-red-600 font-bold" : ""}>
                    {((gemma4?.quality?.artifact_ratio || 0) * 100).toFixed(3)} %
                  </span>
                  {(gemma4?.quality?.artifact_ratio || 0) > 0.01 && (
                    <AlertTriangle className="w-4 h-4 text-red-500" />
                  )}
                </div>
                <div className="text-xs text-gray-500 mt-2">
                  {gemma4?.chars || 0} chars · {((gemma4?.time_ms || 0) / 1000).toFixed(1)}s
                </div>
              </div>
            </div>

            {/* CF Worker Column */}
            <div className={`p-4 ${isCfWinner ? "bg-[#F0FDF4]" : ""}`}>
              <h3 className="font-bold text-gray-800 mb-2">CF Worker (Llama+Gemma4 CF)</h3>
              {isCfWinner && (
                <div className="flex items-center gap-1 text-green-600 font-bold mb-2">
                  <CheckCircle className="w-4 h-4" /> WINNER
                </div>
              )}

              <div className="space-y-1 text-sm text-gray-700">
                <div>
                  Score : <span className={`font-bold ${getScoreColor(cfScore)}`}>
                    {cfScore.toFixed(1)} / 100
                  </span>
                </div>
                <div className="flex gap-4">
                  <span>Dosages : {cf_worker?.quality?.dosages || 0}</span>
                  <span>Posol. : {cf_worker?.quality?.posologies || 0}</span>
                </div>
                <div className="flex items-center gap-1">
                  <span>Artefacts : </span>
                  <span className={(cf_worker?.quality?.artifact_ratio || 0) > 0.01 ? "text-red-600 font-bold" : ""}>
                    {((cf_worker?.quality?.artifact_ratio || 0) * 100).toFixed(3)} %
                  </span>
                  {(cf_worker?.quality?.artifact_ratio || 0) > 0.01 && (
                    <AlertTriangle className="w-4 h-4 text-red-500" />
                  )}
                </div>
                <div className="text-xs text-gray-500 mt-2">
                  {cf_worker?.chars || 0} chars · {((cf_worker?.time_ms || 0) / 1000).toFixed(1)}s
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-amber-200">
            <div className="p-4">
              <details>
                <summary className="text-xs font-semibold text-gray-600 cursor-pointer mb-2">
                  [Voir texte extrait ▼]
                </summary>
                <pre
                  className="text-xs bg-white p-2 rounded border border-gray-200 overflow-y-auto"
                  style={{ maxHeight: "200px", whiteSpace: "pre-wrap" }}
                >
                  {gemma4?.sample || "N/A"}
                </pre>
              </details>
            </div>
            <div className="p-4">
              <details>
                <summary className="text-xs font-semibold text-gray-600 cursor-pointer mb-2">
                  [Voir texte extrait ▼]
                </summary>
                <pre
                  className="text-xs bg-white p-2 rounded border border-gray-200 overflow-y-auto"
                  style={{ maxHeight: "200px", whiteSpace: "pre-wrap" }}
                >
                  {cf_worker?.sample || "N/A"}
                </pre>
              </details>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
